var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38867 12.0693C1.38867 18.0748 6.25714 22.9434 12.2627 22.9434C18.2682 22.9434 23.1367 18.0748 23.1367 12.0693C23.1367 6.06378 18.2682 1.19531 12.2627 1.19531",
    stroke: "#3D50DF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26799 4.54243C4.41842 4.38296 4.57346 4.22789 4.7329 4.0774M7.85508 1.98772C8.05245 1.899 8.25285 1.81579 8.45605 1.73828M1.93164 8.26269C2.00988 8.05747 2.09394 7.85511 2.18361 7.65584",
    stroke: "#3D50DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2637 7.71875V16.418M16.6133 12.0684H7.91406",
    stroke: "#3D50DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.7116b23bbef8c5c3b0a4772b5cbb4104.svg";
export { ForwardRef as ReactComponent };